exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* UU5.Forms.File */\n.uu5-forms-file {\n  margin-top: 0.1em;\n  margin-bottom: 1em;\n}\n.uu5-forms-file:after {\n  display: block;\n  position: relative;\n  content: '';\n  clear: both;\n}\n.uu5-forms-file .uu5-forms-input-button {\n  font-size: inherit;\n}\n.uu5-forms-file-input {\n  visibility: hidden;\n  height: 0;\n  width: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./forms/file.less
// module id = 319
// module chunks = 0